import {throwError as observableThrowError, Observable, BehaviorSubject} from 'rxjs';
import {Location} from '@angular/common';
import {take, filter, catchError, switchMap, finalize, timeout} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {
    HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
    HttpResponse, HttpUserEvent, HttpErrorResponse
} from '@angular/common/http';

import {AuthenticationService} from './authentication.service';
import {ConfigurationService} from '../configuration.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {StateManagerService} from '../state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {Platform} from '@ionic/angular';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(private injector: Injector,
                private location: Location,
                private configurationService: ConfigurationService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private platform: Platform) {
    }

    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        const cloneReq = req.clone({setHeaders: {Authorization: 'Bearer ' + token}});
        console.log('addToken');
        console.log(cloneReq);
        console.log('-------');
        return cloneReq;
    }

    rerouteViaHttps(req: HttpRequest<any>) {
        if (req.url.indexOf('BusinessLogicServices') !== -1) {
            if ((this.platform.is('android') || this.platform.is('ios'))) {
                // do nothing

            } else {
                // only override if we are connecting over https ( this allows the test builds to work )
                console.log(window.location.protocol);

                // const url = new URL( this.location.path() );
                // This line of code was used to proxy the connection
                /*if (window.location.protocol === 'https:') {
                    const cloneReq = req.clone({url: 'https://jpointcloud.dynalias.net:9999', setParams: {'forward': req.url}});
                    console.log('https reroute');
                    console.log(cloneReq);
                    console.log('-------');
                    return cloneReq;
                }*/
            }
        }
        return req;
    }

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        const authService = this.injector.get(AuthenticationService);
        const config: ConfigurationModel = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        console.log('Intercept firing');
        console.log(this.addToken(req, this.tokenSubject.value));
        console.log('-------');

        const requestWithToken = this.addToken(req, this.tokenSubject.value);

        const requestWithRedirectIfNeeded = this.rerouteViaHttps(requestWithToken);

        if (config.offLineMode) {
            return next.handle(requestWithRedirectIfNeeded).pipe(timeout(1),
                catchError(error => {
                    if (error instanceof HttpErrorResponse) {
                        switch ((<HttpErrorResponse>error).status) {
                            case 400:
                                return this.handle400Error(error);
                            case 401:
                                return this.handle401Error(req, next);
                            default:
                                return observableThrowError(error);
                        }
                    } else {
                        return observableThrowError(error);
                    }
                }));
        } else {
            return next.handle(requestWithRedirectIfNeeded).pipe(
                catchError(error => {
                    if (error instanceof HttpErrorResponse) {
                        switch ((<HttpErrorResponse>error).status) {
                            case 400:
                                return this.handle400Error(error);
                            case 401:
                                return this.handle401Error(req, next);
                            default:
                                return observableThrowError(error);
                        }
                    } else {
                        return observableThrowError(error);
                    }
                }));
        }
    }

    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        }

        return observableThrowError(error);
    }

    handle401Error(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            const authService = this.injector.get(AuthenticationService);

            console.log('Running 401 authentication');
            return authService.getAuthenticationObservable().pipe(
                switchMap((newToken: string) => {
                    if (newToken) {

                        console.log('Got new Token ' + newToken);

                        this.tokenSubject.next(newToken);
                        return next.handle(this.addToken(req, newToken));
                    }

                    // If we don't get a new token, we are in trouble so logout.
                    return this.logoutUser();
                }),
                catchError(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    return observableThrowError(error);
                }),
                finalize(() => {
                    this.isRefreshingToken = false;
                }),);
        } else {
            return this.tokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(token => {
                    return next.handle(this.addToken(req, token));
                }),);
        }
    }


    logoutUser() {
        return observableThrowError('');
    }
}
